import { validateFinnishSSN } from '@op/opds.validate';
import { buildElementId } from '../utils';

import {
  ValidateDatePicker,
  ValidateRegExp,
  ValidateSSN,
  ValidateSegmented,
  ValidateSelector,
} from './ElementValidators';

const dataFormater = (newErrors) => ({
  add: newErrors.add.filter(Boolean),
  remove: newErrors.remove.filter(Boolean),
});

const getValue = (answer) => {
  return (answer || { value: '' }).value;
};

const makePersonTypeMe = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  const sportsMessage = getSportsMessage(questions, caption, getMessage);
  const highRiskSportsMessage = getHighRiskSportsMessage(questions, caption, getMessage)
  newErrors = validateSportsMe(newErrors, id, questions, validateAll, questionID, sportsMessage);
  newErrors = validateHRSportsMe(newErrors, id, questions, validateAll, questionID, highRiskSportsMessage);
  newErrors = validateHealth(newErrors, id, questions, validateAll, questionID, caption, getMessage);
  newErrors = validateLife(newErrors, id, questions, validateAll, questionID, caption, getMessage);
  newErrors = validateHealthCoverage(newErrors, id, questions, validateAll, questionID, caption, getMessage);
  newErrors = validateCompetitiveSportsMe(newErrors, id, questions, validateAll, questionID, caption, getMessage)
  newErrors = validateHighRiskSportsMe(newErrors, id, questions, validateAll, questionID, caption, getMessage)

  return dataFormater(newErrors);
};

const getSportsMessage = (questions, caption, getMessage) => {
  let sportsMessage =
    questions.whichSportsMe?.errorLabel ||
    (getMessage
      ? `${caption} : ${
          questions.whichSportsMe?.question ||
          getMessage('labelText.whichSports')
        } - ${getMessage('error.fill.in.missing.information')}`
      : '');
  return sportsMessage.replace(
    '- undefined',
    (getMessage ?? questions.personType.getMessage)(
      'error.fill.in.missing.information'
    )
  );
};

const getHighRiskSportsMessage = (questions, caption, getMessage) => {
  let highRiskSportsMessage =
    questions.whichHighRiskSportsMe?.errorLabel ||
    (getMessage
      ? `${caption} : ${
          questions.whichHighRiskSportsMe?.question ||
          getMessage('labelText.whichHighRiskSports')
        } - ${getMessage('error.fill.in.missing.information')}`
      : '');
  return highRiskSportsMessage.replace(
    '- undefined',
    (getMessage ?? questions.personType.getMessage)(
      'error.fill.in.missing.information'
    )
  );
};

const validateSportsMe = (newErrors, id, questions, validateAll, questionID, sportsMessage) => {
  if (getValue(questions.competitiveSportsMe) === 'Yes') {
    newErrors = ValidateRegExp({
      value: getValue(questions.whichSportsMe),
      id: buildElementId(id, 'PERSON_WHICHSPORTSME'),
      newErrors,
      validateAll,
      length: 1,
      questionID,
      regExp: '^[\\sa-zA-Z0-9åäöÅÄÖ.\\u0023,?!()+-/&:"\'@%€]+$',
      errorLabel: sportsMessage,
    });
  }
  return newErrors;
};

const validateHRSportsMe = (newErrors, id, questions, validateAll, questionID, highRiskSportsMessage) => {
  if (getValue(questions.highRiskSportsMe) === 'Yes') {
    newErrors = ValidateRegExp({
      value: getValue(questions.whichHighRiskSportsMe),
      id: buildElementId(id, 'PERSON_WHICHHIGHRISKSPORTSME'),
      newErrors,
      validateAll,
      length: 1,
      questionID,
      regExp: '^[\\sa-zA-Z0-9åäöÅÄÖ.\\u0023,?!()+-/&:"\'@%€]+$',
      errorLabel: highRiskSportsMessage,
    });
  }
  return newErrors;
};

const validateHealth = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  return ValidateSegmented(
    getValue(questions.health),
    buildElementId(id, 'PERSON_HEALTH'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.health?.question ||
          getMessage('labelText.Health')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
};

const validateLife = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  return ValidateSegmented(
    getValue(questions.Life),
    buildElementId(id, 'PERSON_LIFE'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.Life?.question ||
          getMessage('labelText.Life')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
};

const validateHealthCoverage = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  if (getValue(questions.health) === 'Yes') {
    newErrors = ValidateSelector(
      getValue(questions.healthCoverage),
      buildElementId(id, 'PERSON_HEALTHCOVERAGE'),
      newErrors,
      validateAll,
      questionID,
      getMessage
        ? `${caption} : ${
            questions.healthCoverage?.question ||
            getMessage('labelText.HealthCoverage')
          } - ${getMessage('error.fill.in.missing.information')}`
        : ''
    );
  }
  return newErrors;
};

const validateCompetitiveSportsMe = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  if (getValue(questions.healthCoverage)) {
    newErrors = ValidateSelector(
      getValue(questions.competitiveSportsMe),
      buildElementId(id, 'PERSON_COMPETITIVESPORTSME'),
      newErrors,
      validateAll,
      questionID,
      getMessage
        ? `${caption} : ${
            questions.competitiveSportsMe?.question ||
            getMessage('labelText.competitiveSportsMe')
          } - ${getMessage('error.fill.in.missing.information')}`
        : ''
    );
  }
  return newErrors;
};

const validateHighRiskSportsMe = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  if (getValue(questions.healthCoverage)) {
    newErrors = ValidateSelector(
      getValue(questions.highRiskSportsMe),
      buildElementId(id, 'PERSON_HIGHRISKSPORTSME'),
      newErrors,
      validateAll,
      questionID,
      getMessage
        ? `${caption} : ${
            questions.highRiskSportsMe?.question ||
            getMessage('labelText.highRiskSportsMe')
          } - ${getMessage('error.fill.in.missing.information')}`
        : ''
    );
  }
  return newErrors;
};


const makePersonTypeUnbornOrTwins = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  // Calculated Due Date
  newErrors = ValidateDatePicker(
    (questions.calculatedDueDate || { isInvalid: true }).isInvalid,
    questions,
    buildElementId(id, 'PERSON_CALCULATEDDUEDATE'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.calculatedDueDate?.question ||
          getMessage('labelText.calculatedDueDate')
        } - ${getMessage('errorText.personBirthDate')}`
      : ''
  );
  newErrors = ValidateSegmented(
    getValue(questions.motherChild),
    buildElementId(id, 'PERSON_Mother_Child'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.motherChild?.question ||
          getMessage('labelText.personUnbornMotherChild')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  if (getValue(questions.motherChild) === 'No') {
    newErrors = ValidateSSN(
      getValue(questions.mothersID),
      buildElementId(id, 'PERSON_MOTHERID'),
      newErrors,
      validateAll,
      1,
      questionID,
      validateFinnishSSN(getValue(questions.mothersID)),
      getMessage
        ? `${caption} : ${
            questions.mothersID?.question ||
            getMessage('labelText.mothersIdentificationNumber')
          } - ${getMessage('error.fill.in.missing.information')}`
        : ''
    );
  } else if (getValue(questions.motherChild) === 'Yes') {
    newErrors.remove = [
      ...newErrors.remove,
      buildElementId(id, 'PERSON_MOTHERID'),
    ];
  }

  return dataFormater(newErrors);
};

const validateFirstNameChild = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  let firstNameMessage =
    questions.firstNameChild?.errorLabel ||
    (getMessage
      ? `${caption} : ${
          questions.firstNameChild?.question ||
          getMessage('labelText.FirstName')
        } - ${getMessage('error.fill.in.missing.information')}`
      : '');
  firstNameMessage = firstNameMessage.replace(
    '- undefined',
    (getMessage ?? questions.personType.getMessage)(
      'error.fill.in.missing.information'
    )
  );
  newErrors = ValidateRegExp({
    value: getValue(questions.firstNameChild),
    id: buildElementId(id, 'PERSON_FIRSTNAMECHILD'),
    newErrors,
    validateAll,
    length: 1,
    questionID,
    regExp:
      "(^[a-zA-Z\\u00C0-\\u017F'´`]+([ |-][a-zA-Z\\u00C0-\\u017F'´`]+)*$)|(^$)",
    errorLabel: firstNameMessage,
  });
  return newErrors;
};

const validateLastNameChild = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  let lastNameMessage =
    questions.lastNameChild?.errorLabel ||
    (getMessage
      ? `${caption} : ${
          questions.lastNameChild?.question ||
          getMessage('labelText.LastName')
        } - ${getMessage('error.fill.in.missing.information')}`
      : '');
  lastNameMessage = lastNameMessage.replace(
    '- undefined',
    (getMessage ?? questions.personType.getMessage)(
      'error.fill.in.missing.information'
    )
  );
  newErrors = ValidateRegExp({
    value: getValue(questions.lastNameChild),
    id: buildElementId(id, 'PERSON_LASTNAMECHILD'),
    newErrors,
    validateAll,
    length: 1,
    questionID,
    regExp:
      "(^[a-zA-Z\\u00C0-\\u017F'´`]+([ |-][a-zA-Z\\u00C0-\\u017F'´`]+)*$)|(^$)",
    errorLabel: lastNameMessage,
  });
  return newErrors;
};

const validatePersonSecurityChild = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  newErrors = ValidateSSN(
    getValue(questions.securityIdChild),
    buildElementId(id, 'PERSON_SECURITYCHILD'),
    newErrors,
    validateAll,
    1,
    questionID,
    validateFinnishSSN(getValue(questions.securityIdChild)),
    getMessage
      ? `${caption} : ${
          questions.securityIdChild?.question ||
          getMessage('labelText.SecurityId')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
};

const validateInsuranceScopeChild = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  newErrors = ValidateSelector(
    getValue(questions.insuranceScopeChild),
    buildElementId(id, 'PERSON_INSURANCESCOPECHILD'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.insuranceScopeChild?.question ||
          getMessage('labelText.insuranceScope')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
};

const validateWhichSportsChild = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  let sportsChildMessage =
    questions.whichSportsChild?.errorLabel ||
    (getMessage
      ? `${caption} : ${
          questions.whichSportsChild?.question ||
          getMessage('labelText.whichSports')
        } - ${getMessage('error.fill.in.missing.information')}`
      : '');
  sportsChildMessage = sportsChildMessage.replace(
    '- undefined',
    (getMessage ?? questions.personType.getMessage)(
      'error.fill.in.missing.information'
    )
  );
  newErrors =
    getValue(questions.competitiveSportsChild) === 'Yes'
      ? ValidateRegExp({
          value: getValue(questions.whichSportsChild),
          id: buildElementId(id, 'PERSON_WHICHSPORTSCHILD'),
          newErrors,
          validateAll,
          length: 1,
          questionID,
          regExp: '^[\\sa-zA-Z0-9åäöÅÄÖ.\\u0023,?!()+-/&:"\'@%€]+$',
          errorLabel: sportsChildMessage,
        })
      : newErrors;
  return newErrors;
};

const validateWhichHighRiskSportsChild = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  let highRiskSportsChildMessage =
    questions.whichHighRiskSportsChild?.errorLabel ||
    (getMessage
      ? `${caption} : ${
          questions.whichHighRiskSportsChild?.question ||
          getMessage('labelText.whichSports')
        } - ${getMessage('error.fill.in.missing.information')}`
      : '');
  highRiskSportsChildMessage = highRiskSportsChildMessage.replace(
    '- undefined',
    (getMessage ?? questions.personType.getMessage)(
      'error.fill.in.missing.information'
    )
  );
  newErrors =
    getValue(questions.highRiskSportsChild) === 'Yes'
      ? ValidateRegExp({
          value: getValue(questions.whichHighRiskSportsChild),
          id: buildElementId(id, 'PERSON_WHICHHIGHRISKSPORTSCHILD'),
          newErrors,
          validateAll,
          length: 1,
          questionID,
          regExp: '^[\\sa-zA-Z0-9åäöÅÄÖ.\\u0023,?!()+-/&:"\'@%€]+$',
          errorLabel: highRiskSportsChildMessage,
        })
      : newErrors;
  return newErrors;
};

const makePersonTypeChild = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  newErrors = validateFirstNameChild(newErrors, id, questions, validateAll, questionID, caption, getMessage);
  newErrors = validateLastNameChild(newErrors, id, questions, validateAll, questionID, caption, getMessage);
  newErrors = validatePersonSecurityChild(newErrors, id, questions, validateAll, questionID, caption, getMessage);
  newErrors = validateInsuranceScopeChild(newErrors, id, questions, validateAll, questionID, caption, getMessage);
  newErrors = validateWhichSportsChild(newErrors, id, questions, validateAll, questionID, caption, getMessage);
  newErrors = validateWhichHighRiskSportsChild(newErrors, id, questions, validateAll, questionID, caption, getMessage)
  newErrors = ValidateSelector(
    getValue(questions.competitiveSportsChild),
    buildElementId(id, 'PERSON_COMPETITIVESPORTSCHILD'),
    newErrors,
    validateAll,
    questionID,
    buildMessage(caption, questions, getMessage, "competitiveSportsChild", "labelText.competitiveSportsMe", "error.fill.in.missing.information")
  );
  newErrors = ValidateSelector(
    getValue(questions.highRiskSportsChild),
    buildElementId(id, 'PERSON_HIGHRISKSPORTSCHILD'),
    newErrors,
    validateAll,
    questionID,
    buildMessage(caption, questions, getMessage, "competitiveSportsChild", "labelText.highRiskSportsMe", "error.fill.in.missing.information")
  );
  return dataFormater(newErrors);
};

const validateFirstNameAnotherAdult = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  let firstNameAnotherAdultMessage =
      questions.firstNameAnotherAdult?.errorLabel ||
      (getMessage
        ? `${caption} : ${
            questions.firstNameAnotherAdult?.question ||
            getMessage('labelText.FirstName')
          } - ${getMessage('error.fill.in.missing.information')}`
        : '');
        firstNameAnotherAdultMessage = firstNameAnotherAdultMessage.replace(
      '- undefined',
      (getMessage ?? questions.personType.getMessage)(
        'error.fill.in.missing.information'
      )
  );
  newErrors = ValidateRegExp({
    value: getValue(questions.firstNameAnotherAdult),
    id: buildElementId(id, 'PERSON_FIRSTNAMEANOTHERADULT'),
    newErrors,
    validateAll,
    length: 1,
    questionID,
    regExp:
      "(^[a-zA-Z\\u00C0-\\u017F'´`]+([ |-][a-zA-Z\\u00C0-\\u017F'´`]+)*$)|(^$)",
    errorLabel:firstNameAnotherAdultMessage,
  });
  return newErrors;
};

const validateLastNameAnotherAdult = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  let lastNameAnotherAdultMessage =
    questions.lastNameAnotherAdult?.errorLabel ||
    (getMessage
      ? `${caption} : ${
          questions.lastNameAnotherAdult?.question ||
          getMessage('labelText.LastName')
        } - ${getMessage('error.fill.in.missing.information')}`
      : '');
      lastNameAnotherAdultMessage = lastNameAnotherAdultMessage.replace(
      '- undefined',
      (getMessage ?? questions.personType.getMessage)(
        'error.fill.in.missing.information'
      )
  );
  newErrors = ValidateRegExp({
    value: getValue(questions.lastNameAnotherAdult),
    id: buildElementId(id, 'PERSON_LASTNAMEANOTHERADULT'),
    newErrors,
    validateAll,
    length: 1,
    questionID,
    regExp:
      "(^[a-zA-Z\\u00C0-\\u017F'´`]+([ |-][a-zA-Z\\u00C0-\\u017F'´`]+)*$)|(^$)",
    errorLabel:lastNameAnotherAdultMessage,
  });
  return newErrors;
};

const validatePersonSecurityAnotherAdult = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  newErrors = ValidateSSN(
    getValue(questions.securityIdAnotherAdult),
    buildElementId(id, 'PERSON_SECURITYANOTHERADULT'),
    newErrors,
    validateAll,
    11,
    questionID,
    validateFinnishSSN(getValue(questions.securityIdAnotherAdult)),
    getMessage
    ? `${caption} : ${
        questions.securityIdAnotherAdult?.question ||
        getMessage('labelText.SecurityId')
      } - ${getMessage('error.fill.in.missing.information')}`
    : ''
  );
  return newErrors;
};

const validateWhichSportsAnotherAdult = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  let sportsAnotherAdultMessage =
      questions.whichSportsAnotherAdult?.errorLabel ||
      (getMessage
        ? `${caption} : ${
            questions.whichSportsAnotherAdult?.question ||
            getMessage('labelText.whichSports')
          } - ${getMessage('error.fill.in.missing.information')}`
        : '');
      sportsAnotherAdultMessage = sportsAnotherAdultMessage.replace(
      '- undefined',
      (getMessage ?? questions.personType.getMessage)(
        'error.fill.in.missing.information'
      )
  );
  newErrors =
    getValue(questions.competitiveSportsAnotherAdult) === 'Yes'
      ? ValidateRegExp({
          value: getValue(questions.whichSportsAnotherAdult),
          id: buildElementId(id, 'PERSON_WHICHSPORTSANOTHERADULT'),
          newErrors,
          validateAll,
          length: 1,
          questionID,
          regExp: '^[\\sa-zA-Z0-9åäöÅÄÖ.\\u0023,?!()+-/&:"\'@%€]+$',
          errorLabel: sportsAnotherAdultMessage,
        })
      : newErrors;
  return newErrors;
};

const validateWhichHighRiskSportsAnotherAdult = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  let highRiskSportsAnotherAdultMessage =
      questions.whichHighRiskSportsAnotherAdult?.errorLabel ||
      (getMessage
        ? `${caption} : ${
            questions.whichHighRiskSportsAnotherAdult?.question ||
            getMessage('labelText.whichHighRiskSports')
          } - ${getMessage('error.fill.in.missing.information')}`
        : '');
      highRiskSportsAnotherAdultMessage = highRiskSportsAnotherAdultMessage.replace(
      '- undefined',
      (getMessage ?? questions.personType.getMessage)(
        'error.fill.in.missing.information'
      )
  );
  newErrors =
    getValue(questions.highRiskSportsAnotherAdult) === 'Yes'
      ? ValidateRegExp({
          value: getValue(questions.whichHighRiskSportsAnotherAdult),
          id: buildElementId(id, 'PERSON_WHICHHIGHRISKSPORTSANOTHERADULT'),
          newErrors,
          validateAll,
          length: 1,
          questionID,
          regExp: '^[\\sa-zA-Z0-9åäöÅÄÖ.\\u0023,?!()+-/&:"\'@%€]+$',
          errorLabel: highRiskSportsAnotherAdultMessage,
        })
      : newErrors;
  return newErrors;
};

const buildMessage = (caption, questions, getMessage, currentQuestion, labelKey, errorKey) => {
  if (!getMessage) return '';

  return `${caption} : ${
    questions[currentQuestion]?.question || getMessage(labelKey)
  } - ${getMessage(errorKey)}`;
};

const makePersonTypeAnotherAdult = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  newErrors = validateFirstNameAnotherAdult(newErrors, id, questions, validateAll, questionID, caption, getMessage);
  newErrors = validateLastNameAnotherAdult(newErrors, id, questions, validateAll, questionID, caption, getMessage);
  newErrors = validatePersonSecurityAnotherAdult(newErrors, id, questions, validateAll, questionID, caption, getMessage);
  newErrors = validateWhichSportsAnotherAdult(newErrors, id, questions, validateAll, questionID, caption, getMessage);
  newErrors = validateWhichHighRiskSportsAnotherAdult(newErrors, id, questions, validateAll, questionID, caption, getMessage);

    newErrors = ValidateSelector(
      getValue(questions.healthCoverage),
      buildElementId(id, 'PERSON_HEALTHCOVERAGE'),
      newErrors,
      validateAll,
      questionID,
      buildMessage(caption, questions, getMessage, "healthCoverage", "labelText.insuranceScope", "error.fill.in.missing.information")
    );
    newErrors = ValidateSelector(
      getValue(questions.competitiveSportsAnotherAdult),
      buildElementId(id, 'PERSON_COMPETITIVESPORTSANOTHERADULT'),
      newErrors,
      validateAll,
      questionID,
      buildMessage(caption, questions, getMessage, "competitiveSportsAnotherAdult", "labelText.competitiveSportsMe", "error.fill.in.missing.information")
    );
    newErrors = ValidateSelector(
      getValue(questions.highRiskSportsAnotherAdult),
      buildElementId(id, 'PERSON_HIGHRISKSPORTSANOTHERADULT'),
      newErrors,
      validateAll,
      questionID,
      buildMessage(caption, questions, getMessage, "competitiveSportsAnotherAdult", "labelText.highRiskSportsMe", "error.fill.in.missing.information")
    );
  

  return dataFormater(newErrors);
};

const validatePersonQuestions = (
  id,
  questions,
  validateAll,
  questionID,
  errors,
  caption,
  getMessage
) => {
  let newErrors = { add: [], remove: [] };
  const personType = questions.personType || { value: '' };

  // Mandatory, validate always type
  const errorMessage = getMessage
    ? `${caption} : ${
        personType.question || getMessage('labelText.person')
      } - ${getMessage('error.fill.in.missing.information')}`
    : '';
  newErrors = ValidateSelector(
    personType.value,
    buildElementId(id, 'PERSON_TYPE'),
    newErrors,
    validateAll,
    questionID,
    errorMessage
  );

  if (validateAll === true && personType.value === 'choose') {
    newErrors.remove = [
      ...newErrors.remove,
      ...errors
        .filter(
          (record) =>
            record.id.indexOf(id) !== -1 && record.id !== id + '_PERSON_TYPE'
        )
        .map((record) => record.id),
    ];
  }

  switch (personType.value) {
    case 'Me':
      return makePersonTypeMe(
        newErrors,
        id,
        questions,
        validateAll,
        questionID,
        caption,
        getMessage
      );
    case 'Unborn child or twins':
      return makePersonTypeUnbornOrTwins(
        newErrors,
        id,
        questions,
        validateAll,
        questionID,
        caption,
        getMessage
      );
    case 'Child':
      return makePersonTypeChild(
        newErrors,
        id,
        questions,
        validateAll,
        questionID,
        caption,
        getMessage
      );
    case 'Another adult':
      return makePersonTypeAnotherAdult(
        newErrors,
        id,
        questions,
        validateAll,
        questionID,
        caption,
        getMessage
      );
    default:
      return dataFormater(newErrors);
  }
};
export default validatePersonQuestions;
